import { render, staticRenderFns } from "./NavigationMainLevelItem.vue?vue&type=template&id=7473e9c2&"
import script from "./NavigationMainLevelItem.vue?vue&type=script&lang=js&"
export * from "./NavigationMainLevelItem.vue?vue&type=script&lang=js&"
import style0 from "./NavigationMainLevelItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports